var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.screenMonitoring
    ? _c(
        "div",
        {
          class: ["connection-box", "bottom-md", _vm.screenBoxClass],
          attrs: { name: "step4-check-screen" },
        },
        [
          _c("div", { staticClass: "before" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-dark btn-lg icon icon-connection",
                attrs: { type: "button", name: "connect-screen" },
                on: { click: _vm.handleScreenConnected },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.reconnect
                        ? _vm.$t("preRegistration.step4.screen.reconnect")
                        : _vm.$t("preRegistration.step4.screen.connect")
                    ) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "guide-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.reconnect
                      ? _vm.$t("preRegistration.step4.screen.guide.reconnect")
                      : _vm.$t("preRegistration.step4.screen.guide.connect")
                  ) +
                  "\n    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "after" }, [
            _c("div", { staticClass: "video-box" }, [
              _c("video", {
                staticClass: "face_video",
                attrs: {
                  autoplay: "",
                  playsinline: "",
                  muted: "",
                  id: "screen_connect_check",
                },
                domProps: { muted: true },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cam-print-done" }, [
            _c("div", { staticClass: "icon-confirm" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("preRegistration.step4.screen.connectComplete"))
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }